import React, { useState } from "react";
import { HiEnvelope } from "react-icons/hi2";
import PasswordField from "../input/PasswordField";
import OrangeButton from "../buttons/OrangeButton";
import { useDispatch, useSelector } from "react-redux";
import { AdminLogin } from "../../Redux/Actions/AuthAction";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/images/logo.png";

const LoginCard = () => {
  const { setIsLogin } = useAuth();
  const { loading } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const res = await dispatch(AdminLogin(email, password));
    if (res) {
      setIsLogin(true);
      navigate("/");
    }
  };

  return (
    <div className="login-card">
      <div className="main-card  px-4">
        <div className="w-full max-w-md p-4 bg-white border border-gray-200 rounded-[30px] shadow sm:p-6 md:p-8 ">
          <form className="space-y-6 mb-4" onSubmit={handleLogin}>
            <div className="p-3">
              <div className="flex justify-center items-center">
                <img src={logo} alt="" height={90} width={250} />
              </div>
              <div className="mt-10 mb-4 flex flex-col text-center">
                <span className="font-bold text-2xl text-[#f1580c]">
                  Welcome Back!
                </span>
                <span className="font-semibold text-[14px] text-[#f1580c]">
                  Please enter your details to Login
                </span>
              </div>
            </div>
            <div className="relative">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-semibold text-gray-900"
              >
                Email<span className="text-orange">*</span>
              </label>
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 mt-[27px]">
                <HiEnvelope size={20} className="text-gray-500 " />
              </div>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                name="email"
                id="email"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                placeholder="Enter your email"
              />
            </div>
            <PasswordField setPassword={setPassword} password={password} />
            <div>
              <OrangeButton label={"Login"} loading={loading} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginCard;
